{
    "slides": [
        {
            "name": {
                "es": "FERIARTE 2026",
                "en": "FERIARTE 2026"
            },
            "mobileName": null,
            "imgPath": "assets/img/home-swiper-images/home-feriarte2026.jpg",
            "mobileGradientImgPath": "assets/img/home-swiper-images/home-feriarte2026-mobile-gradient.jpg",
            "subtitleText": {
                "en": "NOVEMBER 21 - 29 <br> Ifema, Feria de Madrid",
                "es": "21 - 29 NOVIEMBRE <br> Ifema, Feria de Madrid"
            },
            "navigateTo": "exhibitions/0",
            "type": "exhibition",
            "text": "left",
            "id": "0"
        },
        {
            "name": {},
            "mobileName": null,
            "imgPath": "assets/img/home-swiper-images/home-augusto.jpg",
            "mobileGradientImgPath": "assets/img/home-swiper-images/home-augusto-mobile-gradient.jpg",
            "subtitleText": {},
            "navigateTo": "artworks/T_7028",
            "type": "artwork",
            "text": "left",
            "id": "T_7028"
        },
        {
            "name": {},
            "mobileName": null,
            "imgPath": "assets/img/home-swiper-images/home-egyptian.jpg",
            "mobileGradientImgPath": "assets/img/home-swiper-images/home-egyptian-mobile-gradient.png",
            "subtitleText": {},
            "navigateTo": "artworks/T_5371",
            "type": "artwork",
            "text": "left",
            "id": "T_5371"
        },
        {
            "name": {},
            "mobileName": null,
            "imgPath": "assets/img/home-swiper-images/home-bronze.jpg",
            "mobileGradientImgPath": "assets/img/home-swiper-images/home-bronze-mobile-gradient.png",
            "subtitleText": {},
            "navigateTo": "artworks/T_5092",
            "type": "artwork",
            "text": "right",
            "id": "T_5092"
        },
        {
            "name": {},
            "mobileName": null,
            "imgPath": "assets/img/home-swiper-images/home-painting.jpg",
            "mobileGradientImgPath": "assets/img/home-swiper-images/home-painting-mobile-gradient.png",
            "subtitleText": {},
            "navigateTo": "paintings/T_6477",
            "type": "artwork",
            "text": "left",
            "id": "T_6477"
        },
          {
            "name": {},
            "mobileName": null,
            "imgPath": "assets/img/home-swiper-images/home-asa.jpg",
            "mobileGradientImgPath": "assets/img/home-swiper-images/home-asa-mobile-gradient.jpg",
            "subtitleText": {},
            "navigateTo": "artworks/T_6397",
            "type": "artwork",
            "text": "left",
            "id": "T_6397"
        },
        {
            "name": {},
            "mobileName": null,
            "imgPath": "assets/img/home-swiper-images/home-adan-eva.png",
            "mobileGradientImgPath": "assets/img/home-swiper-images/home-adan-eva-mobile-gradient.png",
            "subtitleText": {},
            "navigateTo": "paintings/T_6292",
            "type": "artwork",
            "text": "left",
            "id": "T_6292"
        },
        {
            "name": {},
            "mobileName": null,
            "imgPath": "assets/img/home-swiper-images/home-torso-masculino.jpg",
            "mobileGradientImgPath": "assets/img/home-swiper-images/home-torso-masculino-mobile-gradient.jpg",
            "subtitleText": {},
            "navigateTo": "artworks/T_4443",
            "type": "artwork",
            "text": "right",
            "id": "T_4443"
        }
    ]
}